<template>
  <div
    class="bg-lightSecondaryBackgroundColor p-lg dark:bg-darkSecondaryBackgroundColor rounded-md shadow-sm dark:shadow-none"
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>
